export const BACKEND_STEPS_SUBMITTED = ['client_birth_information', 'client_labor_information'];

export const WHEN_BUY_META_KIND = 'simulation_when_buy_meta';

export const STEPS_AFTER_SOCIOECONOMIC = [
  'client_quotes_information',
  'client_financial_information',
  'client_personal_documentation',
  'client_confirmation'
];
